<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-supplier-form modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>{{ keyData ? 'แก้ไขข้อมูลซัพพลายเออร์' : 'เพิ่มรายการซัพพลายเออร์' }}</span>
                        </h4>

                        <button class="btn-close" @click="hide(false)"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form" v-if="formData && errorData">
                            <div class="row">
                                <div class="col-12">
                                    <div class="field">
                                        <label>ชื่อซัพพลายเออร์/ร้านค้า</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.name.blank }"
                                                maxlength="100"
                                                placeholder="ชื่อซัพพลายเออร์/ร้านค้า"
                                                v-model="formData.name" />
                                        <div class="input-error-message" v-if="errorData.name.blank">โปรดกรอกชื่อซัพพลายเออร์/ร้านค้า</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>ชื่อผู้ติดต่อ</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.contactPerson.blank }"
                                                maxlength="100"
                                                placeholder="ชื่อผู้ติดต่อ"
                                                v-model="formData.contactPerson" />
                                        <div class="input-error-message" v-if="errorData.contactPerson.blank">โปรดกรอกชื่อผู้ติดต่อ</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>เบอร์ติดต่อ</label>
                                        <input type="tel" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.contactTel.blank }"
                                                maxlength="20"
                                                placeholder="เบอร์ติดต่อ"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.contactTel" />
                                        <div class="input-error-message" v-if="errorData.contactTel.blank">โปรดกรอกเบอร์ติดต่อ</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="field">
                                        <label>รายละเอียดอื่นๆ</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.detail.blank }"
                                                maxlength="200"
                                                placeholder="ข้อมูลสินค้าที่จำหน่าย"
                                                v-model="formData.detail" />
                                        <div class="input-error-message" v-if="errorData.detail.blank">โปรดกรอกรายละเอียดอื่นๆ</div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 text-right">
                                <button class="btn btn-main" @click="saveSupplier()">บันทึก</button>
                                <button class="btn btn-grey-outline" @click="hide(false)">ปิด</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import DBSupplier from '@/database/Supplier';

export default {
    data() {
        return {
            isActive: false,
            formData: null,
            errorData: null
        };
    },
    props: {
        isDisplay: Boolean,
        keyData: [Number, String]
    },
    watch: {
        async isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.formData = await this.initFormData();
                this.errorData = this.initValidateData();
            }
        }
    },
    methods: {
        hide(isReload) {
            this.$emit('hide', isReload);
        },
        async initFormData() {
            let data = null;

            if (this.keyData) {
                data = await DBSupplier.getDetail(this.keyData);
            }

            return this.mapViewData(data);
        },
        mapViewData(data) {
            return {
                key: data ? data.key : '',
                name: data ? data.name : '',
                contactPerson: data ? data.contactPerson : '',
                contactTel: data ? data.contactTel : '',
                detail: data ? data.detail : ''
            }
        },
        initValidateData() {
            return {
                name: { blank: false },
                contactPerson: { blank: false },
                contactTel: { blank: false },
                detail: { blank: false }
            }
        },
        async saveSupplier() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();
                
                await DBSupplier.save(this.formData);

                this.hide(true);
                loader.hide();
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (!this.formData[property].trim()) {
                    this.errorData[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-supplier-form {
    max-width: 800px;
}
</style>